<template>
  <ul class="sm-tips sm-tips_scrollable sm-tips_refs">
    <li v-for="tip in getTips()" class="sm-tip">
      <button @click="applyTip(tip)" class="sm-tip__cloud" type="button">
        {{ tip }}
      </button>
    </li>
  </ul>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "tips",
  methods: {
    ...mapActions("search", [
        "setQueryFilter",
        "setQString",
        "doSearch",
        "clearTips"
    ]),
    getTips() {
      return this.$store.getters['search/tips'];
    },
    applyTip(tip) {
      const q = this.$store.getters['search/q'];
      this.setQString(q + ' ' + tip);

      this.doSearch().then(() => {
        this.clearTips();
      }).catch(err => {
        console.log(err);
      });
    }
  }
}
</script>